
export const forEachAsync = async <T>(array: T[], cb: (item: T, index: number, array: T[]) => Promise<void> | void) => {
	for (let i = 0; i < array.length; i++) {
		await cb(array[i], i, array);
	}
};
